import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptbrLocale from 'date-fns/locale/pt-BR';
import { Suspense } from 'react';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import BackdropLoading from '@shared/components/backdrop-loading';
import { queryClient } from './config/query-client';
import { Routes } from './routes';
import store, { persistor } from './store';
import { theme } from './theme';

import './theme/global.css';

function App() {
  return (
    <Suspense fallback={<BackdropLoading isOpen />}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={ptbrLocale}
      >
        <ThemeProvider theme={theme}>
          <QueryClientProvider client={queryClient}>
            <Provider store={store}>
              <PersistGate persistor={persistor}>
                <CssBaseline />
                <Routes />
              </PersistGate>
            </Provider>
          </QueryClientProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </Suspense>
  );
}

export default App;
